import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import styled from "styled-components";

type KeyProps = {
  backgroundColor?: Color | null;
};

export const Key = styled.div<KeyProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 100px;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : Color.MidnightBlue};
  margin: 5px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 28px; /* basstorlek för siffrorna */

  @media (max-width: 768px) {
    width: 120px;
    height: 80px;
    border-radius: 16px;
    font-size: 24px;
  }

  @media (max-width: 480px) {
    width: 100px;
    height: 70px;
    border-radius: 14px;
    font-size: 22px;
  }
`;

export const NumberPadContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 600px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 400px;
  }

  @media (max-width: 480px) {
    max-width: 340px;
  }
`;

type FontProps = {
  color?: Color;
  fontSize?: FontSize;
  backgroundColor?: Color;
  fontFamily?: FontFamily;
  padding?: boolean;
  align?: "center" | "left" | "right";
};

export const Text = styled.p<FontProps>`
  color: ${(props) => (props.color ? props.color : Color.MidnightBlue)};
  font-size: ${(props) =>
    props.fontSize ? props.fontSize : FontSize.Standard};
  font-family: ${(props) =>
      props.fontFamily ? props.fontFamily : FontFamily.MontserratRegular},
    Helvetica;
  text-decoration: none;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "none"};
  ${(props) => props.padding && "padding: 5px; border-radius: 4px;"}
  ${(props) => props.align && `text-align: ${props.align};`}
`;
